export default {
  'profile': {
    'info': '信息',
    'password': '密码',
    'avatar': '头像',
    'group': '管理分组',

    'my_info': '我的信息',

    'nickname': '昵称',
    'email': '邮箱',
    'introduce': '简介',
    'introduce_enter': '简介',
    'nickname_dont_empty': '昵称不能为空',
    'email_dont_empty': '邮箱不能为空',
    'save': '提交',
    'info_update_success': '信息更新成功',

    'updata_avatar_tip': '修改头像注意',
    'auto_update_avatar': '选择头像提交后将会自动提交修改头像为选择头像',
    'select_avatar': '选择头像',
    'update_avatar_success': '更新头像成功',

    'old_password': '旧密码',
    'old_password_enter': '请填写旧密码',
    'new_password': '新密码',
    'new_password_enter': '请填写新密码',
    'new_password_confirm': '确认新密码',
    'new_password_confirm_enter': '请再次填写新密码',
    'oldpassword_dont_empty': '旧密码不能为空',
    'newpassword_dont_empty': '新密码不能为空',
    'confirm_newpassword_dont_empty': '确认密码不能为空',
    'updata_password_success': '密码更新成功',
  },
}
